export const getUserDefaultDashboard = (userRole) => {
    switch (userRole) {
    case 'PA':
        return 'admin';
    case 'MA':
        return 'das';
    case 'OM':
        return 'office-manager';
    default:
        return 'consultant';
    }
}

export const getUserDefaultMyOrganization = (userRole) => {
    switch (userRole) {
    case 'PA':
        return 'staffing';
    case 'MA':
        return 'staffing';
    default:
        return 'customers';
    }
}